import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { getCodeTranslation, getCompanyCodeTranslation, listPlaceOfSupply } from '../../graphql';

export const getCodeTranslationApi = createApi({
    reducerPath: 'getCodeTranslation',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getCodeTranslation: builder.query({
            query: (variables) => ({
                body: getCompanyCodeTranslation,
                variables: variables, // Pass type as a variable to the query
            }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, { codetype }) => [{ type: 'CodeTranslation', id: codetype }],
        }),
        listPlaceOfSupply: builder.query({
            query: (variables) => ({
                body: listPlaceOfSupply,
                variables: variables, // Pass type as a variable to the query
            }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags:['PlaceOfSupply'],
        }),
    }),
});

export const { useGetCodeTranslationQuery, useListPlaceOfSupplyQuery } = getCodeTranslationApi;
